import type { Theme } from "./types";

export const defaultTheme: Theme = {
  colors: {
    background: "#ffffff",
    surface: "#fafafa",
    surfaceAlt: "#f3f3f3",

    text: "#111111",
    textMuted: "#777777",

    primary: "#a67816",
    primaryContrast: "#ffffff",

    border: "#e5e5e5",
  },

  fonts: {
    heading: "serif",
    body: "sans-serif",
  },

  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 40,

    section: 80,
    container: 1100,
  },

  radius: {
    sm: 6,
    md: 10,
    lg: 16,
  },

  shadow: {
    sm: "0 1px 4px rgba(0,0,0,0.06)",
    md: "0 6px 20px rgba(0,0,0,0.08)",
  },
};
